module.exports = __webpack_public_path__ + "static/media/21.9ea6b863.jpg";